<template>
  <div @click="openAlertModal">
    <a v-if="isFollowUpPage" class="button">Start follow up</a>
    <img v-else class="alert_button btn" src="/clock.svg">
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
export default {
  name: 'alert-button',
  props: ['payload', 'additional_data'],
  computed: {
    getResourceType () {
      if (this.additional_data == undefined) {
        return this.payload.resource_type
      }
      return this.additional_data.resource_type
    },
    isFollowUpPage () {
      return this.$route.name == 'admin-alerts'
    },
    resourceComponent () {
      switch (this.getResourceType) {
        case 'Company':
          return {
            component: 'CompanyAlertsForm',
            width: 1200
          }
        case 'Applicant':
          return {
            component: 'ApplicantAlertsForm',
            width: 2000
          }
        default:
          return {
            component: 'ResourceAlertsForm',
            width: 1200
          }
      }
    }
  },
  methods: {
    openAlertModal () {
      this.create({
        designator: 'resource-alerts-form-modal',
        component_name: this.resourceComponent.component,
        modal_width: this.resourceComponent.width,
        is_center_modal: true,
        data: this.payload,
        resource_type: this.getResourceType,
        modal_title: this.getTitle()
      })
    },
    getTitle () {
      let title = 'Alerts - ' + this.$utils.getResourceFullName({ resource_type: this.getResourceType, data: this.payload })
      if (this.getResourceType == 'Applicant') {
        return `${title} ${this.payload.phone_number}`
      }
      return title
    },
    ...mapMutations('modals', ['create'])
  }
}
</script>
<style scoped>
  .alert_button{
    max-width: 30px;
  }
  .button {
    font-size: 0.7em;
    color:  white;
    background-color: gray;
  }
</style>
